import { MIGRATION_PATHS } from "src/templates/constants";
import { normalizePathname } from "src/lib/normalizePathname";

export const getMigrationProductName = (pathname: string): string | undefined =>
  MIGRATION_PATHS[normalizePathname(pathname)];
